export default __webpack_public_path__ + "static/media/logo_dbd.59d62847.jpg";